<div class="loader" *ngIf="isLoading$ | async">
    <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>
